import api from "@/api/api.js";

/** Los dos modos que entiende el servidor; el backend valida el mismo par. */
export const AUTH_MODES = {
  API_KEY: "api_key",
  OAUTH: "oauth",
};

export const getMcpConfiguration = () =>
  api.get("/mcp/configuration").then(({ data }) => data);

export const saveMcpConfiguration = (configuration) =>
  api.put("/mcp/configuration", configuration).then(({ data }) => data);

export const listMcpCredentials = () =>
  api.get("/mcp/credentials").then(({ data }) => data);

/** La llave en claro viene sólo en esta respuesta: no hay forma de volver a pedirla. */
export const issueMcpCredential = (name) =>
  api.post("/mcp/credentials", { name }).then(({ data }) => data);

export const revokeMcpCredential = (id) =>
  api.delete(`/mcp/credentials/${id}`).then(({ data }) => data);

/**
 * Lo que hay que enseñarle al contador cuando algo falla.
 *
 * Estos controladores contestan `{error: "..."}` con el motivo ya escrito en
 * castellano —que el RFC no existe, que faltan datos de OAuth—, así que se
 * muestra tal cual. Sólo cuando no hay nada que mostrar se cae al genérico.
 */
export const mcpError = (
  error,
  fallback = "No se pudo completar la operación.",
) =>
  error?.response?.data?.error ||
  error?.response?.data?.["hydra:description"] ||
  fallback;
